import React, { useState } from "react";
import classes from "./DragDropArea.module.css"

const DragDropArea = function ({files, setFiles, fileType, dropAreaCaption = "Прикрепить файл"}) {
    const [drag, setDrag] = useState(true);
    const dragHandler = function (event) {
        event.preventDefault()
        setDrag(false);
    }
    const unDragHandler = function (event) {
        event.preventDefault()
        setDrag(true);
    }
    const dropHandler = function (event) {
        event.preventDefault()
        let files = [...event.dataTransfer.files]
        if (fileType!==null){
            setFiles(
                files.filter(file => file.type === fileType)
            )
        } else setFiles(files)
        setDrag(true);
    }

    return (
        <div className={classes.dropArea}
            onDragStart={event => dragHandler(event)}
            onDragLeave={event => unDragHandler(event)}
            onDragOver={event => dragHandler(event)}
            onDrop={event => dropHandler(event)}
        >
            {!drag
                ? <span> Отпустите файл</span>
                : <>
                    {files.length>0
                        ? <span>{files[0].name}</span>
                        : <span>{dropAreaCaption}</span>
                    }
                </>
            }
        </div>
    )
}

export default DragDropArea;